import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'finEncode',
  pure: false,
  standalone: false,
})
export class EncodePipe implements PipeTransform {
  transform(inputString: string): string {
    return `https://finnair.com${encodeURI(inputString)}`;
  }
}
